// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stock-table-count-cell {
  width: 130px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
}
.stock-table-count-cell__count-controls {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  font-size: 13px;
}
.stock-table-count-cell__count-controls__count {
  width: 20px;
  position: relative;
  display: flex;
  align-items: center;
  gap: 4px;
}
.stock-table-count-cell__count-controls__count .edit-icon {
  font-size: 8px;
  color: #726BEA;
  opacity: 0.6;
}
.stock-table-count-cell__count-controls__count:hover {
  background-color: rgba(0, 0, 0, 0.04);
}
.stock-table-count-cell__count-controls__count:hover .edit-icon {
  opacity: 1;
}
.stock-table-count-cell__count-controls__button {
  width: 19px;
  height: 23px;
  color: #726BEA;
  border-radius: 3px;
  font-size: 3px !important;
  border-color: #EFEFEF;
  background-color: transparent;
}
.stock-table-count-cell__count-controls__button span {
  font-size: 10px;
  font-weight: bold;
}
.stock-table-count-cell__destination-selector {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.1rem;
  justify-content: space-between;
}
.stock-table-count-cell__destination-selector__item {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.1rem;
  font-size: 9px;
}
.stock-table-count-cell__dropdown {
  width: 100%;
  height: 20px;
  font-size: 10px;
}
.stock-table-count-cell__update-button, .stock-table-count-cell__cancel-button {
  width: 100%;
  height: 30px;
  border-radius: 6px;
  font-size: 12px;
}
.stock-table-count-cell__update-button {
  background-color: #4F4BFF;
  color: white;
  border-color: #DEDEDE;
}
.stock-table-count-cell__cancel-button {
  background-color: transparent;
  color: black;
  border-color: #DEDEDE;
}

.p-radiobutton .p-radiobutton-box {
  height: 20px;
  width: 15px;
  border-radius: 3px;
}

.p-radiobutton.p-highlight .p-radiobutton-box {
  border-color: #4F4BFF;
  background-color: #4F4BFF;
}

.p-radiobutton-icon {
  visibility: hidden;
}

@media screen and (max-width: 768px) {
  .stock-table-count-cell {
    width: 100%;
  }
  .stock-table-count-cell__count-controls {
    width: 100%;
    justify-content: center;
  }
  .stock-table-count-cell__count-controls__button {
    width: 24px;
    height: 24px;
  }
  .stock-table-count-cell__update-button, .stock-table-count-cell__cancel-button {
    height: 28px;
    font-size: 0.75rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/features/profile/components/stock-table-count-cell/stock-table-count-cell.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;AACJ;AACI;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;AACR;AACQ;EACI,WAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AACZ;AACY;EACI,cAAA;EACA,cAAA;EACA,YAAA;AAChB;AAEY;EACI,qCAAA;AAAhB;AACgB;EACI,UAAA;AACpB;AAIQ;EACI,WAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,yBAAA;EACA,qBAAA;EACA,6BAAA;AAFZ;AAIY;EACI,eAAA;EACA,iBAAA;AAFhB;AAOI;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;EACA,8BAAA;AALR;AAOQ;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;EACA,cAAA;AALZ;AASI;EACI,WAAA;EACA,YAAA;EACA,eAAA;AAPR;AAUI;EAEI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;AATR;AAYI;EACI,yBAAA;EACA,YAAA;EACA,qBAAA;AAVR;AAaI;EACI,6BAAA;EACA,YAAA;EACA,qBAAA;AAXR;;AAiBI;EACI,YAAA;EACA,WAAA;EACA,kBAAA;AAdR;;AAkBA;EACI,qBAAA;EACA,yBAAA;AAfJ;;AAkBA;EACI,kBAAA;AAfJ;;AAkBA;EACI;IACI,WAAA;EAfN;EAiBM;IACI,WAAA;IACA,uBAAA;EAfV;EAiBU;IACI,WAAA;IACA,YAAA;EAfd;EAmBM;IAEI,YAAA;IACA,kBAAA;EAlBV;AACF","sourcesContent":[".stock-table-count-cell {\n    width: 130px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 0.5rem;\n    \n    &__count-controls {\n        width: 100%;\n        display: flex;\n        flex-direction: row;\n        align-items: center;\n        justify-content: center;\n        gap: 0.75rem;\n        font-size: 13px;\n\n        &__count {\n            width: 20px;\n            position: relative;\n            display: flex;\n            align-items: center;\n            gap: 4px;\n            \n            .edit-icon {\n                font-size: 8px;\n                color: #726BEA;\n                opacity: 0.6;\n            }\n\n            &:hover {\n                background-color: rgba(0, 0, 0, 0.04);\n                .edit-icon {\n                    opacity: 1;\n                }\n            }\n        }\n\n        &__button {\n            width: 19px;\n            height: 23px;\n            color: #726BEA;\n            border-radius: 3px;\n            font-size: 3px !important;\n            border-color: #EFEFEF;\n            background-color: transparent;\n            \n            span {\n                font-size: 10px;\n                font-weight: bold;\n            }\n        }\n    }\n\n    &__destination-selector {\n        width: 100%;\n        display: flex;\n        flex-direction: row;\n        align-items: center;\n        gap: 0.1rem;\n        justify-content: space-between;\n        \n        &__item {\n            display: flex;\n            flex-direction: row;\n            align-items: center;\n            gap: 0.1rem;\n            font-size: 9px;\n        }\n    }\n\n    &__dropdown {\n        width: 100%;\n        height: 20px;\n        font-size: 10px;\n    }\n\n    &__update-button,\n    &__cancel-button {\n        width: 100%;\n        height: 30px;\n        border-radius: 6px;\n        font-size: 12px;\n    }\n\n    &__update-button {\n        background-color: #4F4BFF;\n        color: white;\n        border-color: #DEDEDE;\n    }\n\n    &__cancel-button {\n        background-color: transparent;\n        color: black;\n        border-color: #DEDEDE;\n    }\n}\n\n// Radio button styles\n.p-radiobutton {\n    .p-radiobutton-box {\n        height: 20px;\n        width: 15px;\n        border-radius: 3px;\n    }\n}\n\n.p-radiobutton.p-highlight .p-radiobutton-box {\n    border-color: #4F4BFF;\n    background-color: #4F4BFF;\n}\n\n.p-radiobutton-icon {\n    visibility: hidden;\n}\n\n@media screen and (max-width: 768px) {\n    .stock-table-count-cell {\n        width: 100%;\n        \n        &__count-controls {\n            width: 100%;\n            justify-content: center;\n            \n            &__button {\n                width: 24px;\n                height: 24px;\n            }\n        }\n        \n        &__update-button,\n        &__cancel-button {\n            height: 28px;\n            font-size: 0.75rem;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
